<template>
  <form class="row" @submit.prevent="auth">
    <div class="element">
      <label>
        <input
          v-model="email"
          required
          type="email"
          placeholder="E-mail"
        >
      </label>
    </div>
    <div class="element">
      <label>
        <input
          v-model="password"
          required
          type="password"
          placeholder="Пароль"
        >
      </label>
    </div>

    <div class="element">
      <button type="submit">Войти</button>
    </div>
  </form>
</template>

<script>
import axios from 'axios'
import { signIn } from '../../../api/auth'
import { baseUrl, setAuthToken } from '../../../api/config'
import User from '../../../helpers/user'
import { needSocketAuth } from '@/api/config'

export default {
  name: 'Login',
  data () {
    return {
      email: '',
      password: ''
    }
  },
  methods: {
    auth () {
      if (needSocketAuth)
        if (!this.$store.getters.signatureKey) {
          this.$store.dispatch('showErrorMessage', 'Идет верификация, попробуйте через несколько секунд')
          return
        }

      signIn({
        email: this.email,
        password: this.password
      }, this.$store.getters.signatureKey).then(response => {
        setAuthToken(response.data.access_token)
        axios.get(`${baseUrl}/users/me`).then(response2 => {
          User.signIn(response.data.access_token, response2.data.roles.map(item => item.name))
          if (User.isAuth() && User.hasAccess()) {
            this.$store.commit('SET_AUTH_USER', response2.data)
            this.$router.push('/games')
          } else {
            alert('Нет прав!!')
          }
        })
      })
        .catch(error => {
          if ([404, 401, 422].includes(error.response.status))
            alert('Неверная пара логин/пароль')
        })
    }
  }
}
</script>

<style scoped>
    .row {
        display: flex;
        flex-direction: column;
    }

    .element {
        font-size: 20px;
        padding: 10px 0 10px 0;
        margin: auto;
    }

    .element input {
        border: #cfd7ce solid 2px;
        border-radius: 3px;
        padding: 2px 7px;
    }

    .element button {
        border: #cfd7ce solid 2px;
        border-radius: 3px;
        padding: 2px 7px;
    }

    .element button:hover {
        background: #cfd7ce;
    }
</style>
